export const StepFields = {
    Duration: 'duration',
    StrokeType: 'strokeType',
    Equipment: 'equipment',
    IntensityTarget: 'intensityTarget',
    SecondaryTarget: 'secondaryTarget',
    Exercises: 'exercises',
    Weight: 'weight',
    Drill: 'drill'
};

export const DurationInputType = {
    SwimmingDistanceDropdown: 'swimmingDistanceDropdown',
    CustomSwimmingDistance: 'customSwimmingDistance',
    TimeInput: 'timeInput',
    UnspecifiedPoolSize: 'unspecifiedPoolSize',
    None: 'none'
};

// CA-169978: when showPoolSwim2 feature flag is removed change the reapeat min to 1 in the line below
export const REPEAT_STEP_ITERATIONS_MIN = 2;
export const REPEAT_STEP_ITERATIONS_MAX = 40;
export const REPEAT_TIMES_DEFAULT = 2;

export const DEFAULT_REPS = 10;

export const DurationCompare = {
    Above: {
        value: 'gt',
        textKey: 'workout:workout.step.duration.power.zone.above'
    },
    Below: {
        value: 'lt',
        textKey: 'workout:workout.step.duration.power.zone.below'
    }
};

export const MAX_POUNDS_FOR_EXERCISE = 999.9;
